import { initials } from "../../utils/format.js";

const SIZES = { sm: 32, md: 40, lg: 56, xl: 96 };

/**
 * Avatar — renders the uploaded image when present, otherwise an initial badge.
 * Used by the header user pill, the sidebar footer and the profile hero so all
 * three stay visually in sync.
 */
export default function Avatar({
  src,
  name,
  size = "md",
  className = "",
  ring = false,
  alt,
}) {
  const dimension = SIZES[size] ?? SIZES.md;

  return (
    <span
      className={`relative inline-flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface-container-highest font-headline font-bold text-on-surface-variant ${
        ring ? "ring-2 ring-primary/40" : ""
      } ${className}`}
      style={{ width: dimension, height: dimension, fontSize: dimension * 0.36 }}
    >
      {src ? (
        <img
          src={src}
          alt={alt || (name ? `${name} avatar` : "Avatar")}
          className="h-full w-full object-cover"
        />
      ) : (
        <span aria-hidden="true">{initials(name)}</span>
      )}
    </span>
  );
}
